import http from "@/utils/request";

class DeclareEnterpriseApi {
  add(data) {
    return http.sendRequest({
      METHOD_NAME: "customsEnterprise.add",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  }

  edit(data) {
    return http.sendRequest({
      METHOD_NAME: "customsEnterprise.editDeclareEnterprise",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  }

  listDeclareEnterprise(data) {
    return http.sendRequest({
      METHOD_NAME: "customsEnterprise.listCustomsEnterprise",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  }

  bindConfChannel(data) {
    return http.sendRequest({
      METHOD_NAME: "customsEnterprise.bindConfChannelInfo",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  }

  listChannelEnterprise(data) {
    return http.sendRequest({
      METHOD_NAME: "customsEnterprise.listChannelEnterprise",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  }
}

export default new DeclareEnterpriseApi();
